export const US_HEIGHT_UNIT = 'FT_IN';

export const HEIGHT_UNIT_LABEL = {
  [US_HEIGHT_UNIT]: 'ft/in',
  FT: 'ft',
  IN: 'in',
  CM: 'cm',
};

export const WEIGHT_UNIT_LABEL = {
  LBS: 'lbs',
  KG: 'kg',
};

export const SHOE_SIZE_UNIT_LABEL = {
  US: 'US',
  UK: 'UK',
  EU: 'EU',
  AU: 'AU',
  CM: 'cm',
};
